import axios from 'axios'
import Cookies from 'js-cookie'
import config from '../config'

export const fetchCouponType = async () => {
  try {
    const response = await axios.get(`${config.apiAdminGateway}/api/v1/admin/coupons`, {
      headers: {
        Authorization: `Bearer ${Cookies.get('accessToken')}`,
      },
    })
    const result = response.data.data
    const couponType = {
      SLOT: result.find((item) => item.type === 'SLOT').id,
      DELIVER: result.find((item) => item.type === 'DELIVER').id,
    }
    localStorage.setItem('coupons', JSON.stringify(couponType))
  } catch (error) {
    console.error(error)
  }
}

export const checkCouponType = (couponId) => {
  const coupons = JSON.parse(localStorage.getItem('coupons'))
  if (!coupons) {
    return '-'
  }
  switch (couponId) {
    case coupons.SLOT:
      return 'SLOT'
    case coupons.DELIVER:
      return 'DELIVER'
    default:
      return '-'
  }
}
